import { Injectable } from '@angular/core'
import { UserStore } from '../store/user/user.store'
import { RoleStore } from '../store/roles/roles.store'

@Injectable({ providedIn: 'root' })
export class StoreResetService {
  constructor(
    private readonly userStore: UserStore,
    private readonly roleStore: RoleStore,
  ) {}

  resetAll() {
    this.userStore.reset()
    this.roleStore.reset()
  }
}
